import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_26: DocMigration = {
  maxSchemaVersion: "0.0.26",
  apply(json: any) {
    if (json.locked) {
      for (const id of Object.keys(json.locked)) {
        const type = json.locked[id]?.type;
        if (type === "ELECTRICAL_ROOM_LAYOUT_GROUP" || type === "ELECTRICAL_INDEPENDENT_LOAD_ARRAY") {
          delete json.locked[id];
        }
      }
    }

    if (json.hidden) {
      for (const id of Object.keys(json.hidden)) {
        const type = json.hidden[id]?.type;
        if (type === "ELECTRICAL_ROOM_LAYOUT_GROUP" || type === "ELECTRICAL_INDEPENDENT_LOAD_ARRAY") {
          delete json.hidden[id];
        }
      }
    }

    return json;
  },
};

export default migration_0_0_26;
